// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './set-public-path'
import Vue from 'vue'
import App from './App'
import router from './router'
import ConsoleTooltipText from './components/shared/ConsoleTooltipText.vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.component('ConsoleTooltipText', ConsoleTooltipText)

function installMobileZoomGuard () {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }

  const isTouchDevice = window.matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0

  if (!isTouchDevice) {
    return
  }

  const preventGesture = function (event) {
    event.preventDefault()
  }

  const preventMultiTouch = function (event) {
    if (event.touches && event.touches.length > 1) {
      event.preventDefault()
    }
  }

  document.addEventListener('gesturestart', preventGesture, { passive: false })
  document.addEventListener('gesturechange', preventGesture, { passive: false })
  document.addEventListener('gestureend', preventGesture, { passive: false })
  document.addEventListener('touchstart', preventMultiTouch, { passive: false })
  document.addEventListener('touchmove', preventMultiTouch, { passive: false })
}

installMobileZoomGuard()

const siteName = '数企推'
const siteWebsiteName = '数企推官网'
const serviceName = '企业数字名片与增长门户解决方案'
const serviceType = '数字名片、官网展示、内容分发、线索转化'
const siteBaseUrl = 'https://www.shuqitui.com'
const siteCanonicalUrl = siteBaseUrl + '/'
const siteContactEmail = 'hello@shuqitui.com'
const siteLogo = {
  url: siteBaseUrl + '/static/shuqitui-logo.png',
  width: 320,
  height: 292
}
const siteSocialImage = {
  url: siteBaseUrl + '/static/shuqitui-og-card.png',
  width: 1200,
  height: 630,
  alt: '数企推企业数字名片、企业官网与线索转化解决方案分享图'
}
const siteSameAs = [
  'https://shuqitui.com/'
]
const siteFaqItems = [
  {
    question: '数企推适合哪些企业？',
    answer: '适合制造业、ToB 服务、招商加盟、软件公司、顾问团队，以及希望统一企业官网与员工名片展示的组织。'
  },
  {
    question: '数企推能解决什么问题？',
    answer: '可以解决官网更新慢、员工名片不统一、活动页重复开发、客户访问无数据沉淀、留资承接路径割裂等问题。'
  },
  {
    question: '数企推官网和数字名片可以一起交付吗？',
    answer: '可以。官网首页、数字名片、专题活动页、内容库搭建和留资表单可以按统一品牌体系一并交付。'
  }
]

const defaultSeo = {
  title: siteName + ' | 企业数字名片、企业官网与线索转化解决方案',
  description: '数企推为企业提供数字名片、手机官网、品牌展示、内容分发与线索转化解决方案，帮助市场、销售、服务与渠道团队统一对外形象并持续获客。',
  keywords: '数企推, 数字名片, 企业官网, 手机官网, 品牌展示, 内容分发, 线索转化, 营销获客, 小程序名片',
  robots: 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1'
}

function upsertMetaTag (attrName, attrValue, content) {
  let el = document.head.querySelector('meta[' + attrName + '="' + attrValue + '"]')

  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attrName, attrValue)
    document.head.appendChild(el)
  }

  el.setAttribute('content', content)
}

function removeMetaTag (attrName, attrValue) {
  const el = document.head.querySelector('meta[' + attrName + '="' + attrValue + '"]')

  if (el && el.parentNode) {
    el.parentNode.removeChild(el)
  }
}

function upsertLinkTag (rel, href) {
  let el = document.head.querySelector('link[rel="' + rel + '"]')

  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    document.head.appendChild(el)
  }

  el.setAttribute('href', href)
}

function removeLinkTag (rel) {
  const el = document.head.querySelector('link[rel="' + rel + '"]')

  if (el && el.parentNode) {
    el.parentNode.removeChild(el)
  }
}

function upsertJsonLdScript (id, data) {
  let el = document.head.querySelector('script[data-seo-id="' + id + '"]')

  if (!el) {
    el = document.createElement('script')
    el.setAttribute('type', 'application/ld+json')
    el.setAttribute('data-seo-id', id)
    document.head.appendChild(el)
  }

  el.text = JSON.stringify(data)
}

function removeJsonLdScript (id) {
  const el = document.head.querySelector('script[data-seo-id="' + id + '"]')

  if (el && el.parentNode) {
    el.parentNode.removeChild(el)
  }
}

function buildStructuredData (route, meta, canonicalUrl) {
  if (meta.structuredData === false || route.name !== 'OfficialSite') {
    return null
  }

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': siteCanonicalUrl + '#organization',
        name: siteName,
        description: '数企推为企业提供数字名片、企业官网、内容分发与线索转化解决方案。',
        url: siteCanonicalUrl,
        email: siteContactEmail,
        logo: {
          '@type': 'ImageObject',
          '@id': siteCanonicalUrl + '#logo',
          url: siteLogo.url,
          contentUrl: siteLogo.url,
          width: siteLogo.width,
          height: siteLogo.height
        },
        image: {
          '@type': 'ImageObject',
          '@id': siteCanonicalUrl + '#primaryimage',
          url: siteSocialImage.url,
          contentUrl: siteSocialImage.url,
          width: siteSocialImage.width,
          height: siteSocialImage.height
        },
        sameAs: siteSameAs,
        contactPoint: [
          {
            '@type': 'ContactPoint',
            contactType: 'sales',
            email: siteContactEmail,
            url: siteCanonicalUrl,
            areaServed: 'CN',
            availableLanguage: ['zh-CN', 'en']
          }
        ]
      },
      {
        '@type': 'WebSite',
        '@id': siteCanonicalUrl + '#website',
        name: siteWebsiteName,
        inLanguage: 'zh-CN',
        description: '企业数字名片、企业官网与线索转化解决方案。',
        url: siteCanonicalUrl,
        publisher: {
          '@id': siteCanonicalUrl + '#organization'
        }
      },
      {
        '@type': 'Service',
        '@id': siteCanonicalUrl + '#service',
        name: serviceName,
        serviceType: serviceType,
        areaServed: 'CN',
        provider: {
          '@id': siteCanonicalUrl + '#organization'
        }
      },
      {
        '@type': 'WebPage',
        '@id': (canonicalUrl || siteCanonicalUrl) + '#webpage',
        name: meta.title,
        description: meta.description,
        inLanguage: 'zh-CN',
        url: canonicalUrl || siteCanonicalUrl,
        isPartOf: {
          '@id': siteCanonicalUrl + '#website'
        },
        about: {
          '@id': siteCanonicalUrl + '#service'
        },
        primaryImageOfPage: {
          '@id': siteCanonicalUrl + '#primaryimage'
        }
      },
      {
        '@type': 'FAQPage',
        '@id': siteCanonicalUrl + '#faq',
        mainEntity: siteFaqItems.map(function (item) {
          return {
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.answer
            }
          }
        })
      }
    ]
  }
}

function removeSeoTagSet () {
  removeMetaTag('property', 'og:url')
  removeMetaTag('property', 'og:image')
  removeMetaTag('property', 'og:image:secure_url')
  removeMetaTag('property', 'og:image:type')
  removeMetaTag('property', 'og:image:width')
  removeMetaTag('property', 'og:image:height')
  removeMetaTag('property', 'og:image:alt')
  removeMetaTag('name', 'twitter:image')
  removeMetaTag('name', 'twitter:image:alt')
  removeLinkTag('canonical')
}

function applySocialPreviewMeta (canonicalUrl) {
  upsertLinkTag('canonical', canonicalUrl)
  upsertMetaTag('property', 'og:url', canonicalUrl)
  upsertMetaTag('property', 'og:image', siteSocialImage.url)
  upsertMetaTag('property', 'og:image:secure_url', siteSocialImage.url)
  upsertMetaTag('property', 'og:image:type', 'image/png')
  upsertMetaTag('property', 'og:image:width', String(siteSocialImage.width))
  upsertMetaTag('property', 'og:image:height', String(siteSocialImage.height))
  upsertMetaTag('property', 'og:image:alt', siteSocialImage.alt)
  upsertMetaTag('name', 'twitter:image', siteSocialImage.url)
  upsertMetaTag('name', 'twitter:image:alt', siteSocialImage.alt)
}

function applyRouteSeo (route) {
  const meta = Object.assign({}, defaultSeo, route.meta || {})
  const isIndexable = !/noindex/i.test(meta.robots || '')
  const isHttpProtocol = /^https?:$/.test(window.location.protocol)
  const isOfficialSite = route.name === 'OfficialSite'
  const canonicalUrl = isHttpProtocol && isIndexable ? siteBaseUrl + route.path : ''

  document.documentElement.setAttribute('lang', 'zh-CN')
  document.title = meta.title

  upsertMetaTag('name', 'description', meta.description)
  upsertMetaTag('name', 'keywords', meta.keywords || defaultSeo.keywords)
  upsertMetaTag('name', 'robots', meta.robots)
  upsertMetaTag('name', 'googlebot', meta.robots)
  upsertMetaTag('name', 'baiduspider', meta.robots)
  upsertMetaTag('property', 'og:type', 'website')
  upsertMetaTag('property', 'og:locale', 'zh_CN')
  upsertMetaTag('property', 'og:site_name', '数企推')
  upsertMetaTag('property', 'og:title', meta.title)
  upsertMetaTag('property', 'og:description', meta.description)
  upsertMetaTag('name', 'twitter:card', isOfficialSite && isIndexable ? 'summary_large_image' : 'summary')
  upsertMetaTag('name', 'twitter:title', meta.title)
  upsertMetaTag('name', 'twitter:description', meta.description)

  if (isHttpProtocol && isIndexable && isOfficialSite) {
    applySocialPreviewMeta(canonicalUrl || siteCanonicalUrl)
  } else {
    removeSeoTagSet()
  }

  const structuredData = buildStructuredData(route, meta, canonicalUrl)

  if (structuredData) {
    upsertJsonLdScript('route-webpage', structuredData)
  } else {
    removeJsonLdScript('route-webpage')
  }
}

router.afterEach((to) => {
  applyRouteSeo(to)
})

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  render: function (createElement) {
    return createElement(App)
  },
  mounted: function () {
    // Vue 挂载完成后添加 mounted 类，触发平滑过渡
    setTimeout(function () {
      document.getElementById('app').classList.add('mounted')
    }, 10)
  }
})

applyRouteSeo(router.currentRoute)



// WEBPACK FOOTER //
// ./src/main.js